import React, { useEffect, useMemo, useState } from 'react';
import { CircleMarker, Marker, Popup, Tooltip, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import Supercluster from 'supercluster';

const clusterIcon = (count, size) => L.divIcon({
    html: `<div style="width:${size}px;height:${size}px" class="flex items-center justify-center rounded-full text-white font-semibold shadow-md" data-testid="map-cluster">${count}</div>`,
    className: 'pezzaioli-cluster',
    iconSize: [size, size],
});

// Raggruppa i punti vicini in bolle numerate; al click fa zoom per aprirle.
export const ClusterLayer = ({ points, renderPoint }) => {
    const map = useMap();
    const [view, setView] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });

    useMapEvents({
        moveend: () => setView({ zoom: map.getZoom(), bounds: map.getBounds() }),
        zoomend: () => setView({ zoom: map.getZoom(), bounds: map.getBounds() }),
    });

    const index = useMemo(() => {
        const sc = new Supercluster({ radius: 60, maxZoom: 15, minPoints: 3 });
        sc.load(points.map((p, i) => ({
            type: 'Feature',
            geometry: { type: 'Point', coordinates: [p.lng, p.lat] },
            properties: { idx: i },
        })));
        return sc;
    }, [points]);

    useEffect(() => { setView({ zoom: map.getZoom(), bounds: map.getBounds() }); }, [map, points]);

    const clusters = useMemo(() => {
        const b = view.bounds;
        const bbox = [Math.max(-180, b.getWest() - 5), Math.max(-85, b.getSouth() - 5), Math.min(180, b.getEast() + 5), Math.min(85, b.getNorth() + 5)];
        return index.getClusters(bbox, Math.round(view.zoom));
    }, [index, view]);

    return (
        <>
            {clusters.map((c) => {
                const [lng, lat] = c.geometry.coordinates;
                if (c.properties.cluster) {
                    const count = c.properties.point_count;
                    const size = Math.max(32, Math.min(64, 26 + Math.log2(count) * 6));
                    return (
                        <Marker
                            key={`cluster-${c.id}`}
                            position={[lat, lng]}
                            icon={clusterIcon(count, size)}
                            eventHandlers={{
                                click: () => {
                                    const z = Math.min(index.getClusterExpansionZoom(c.id), 17);
                                    map.flyTo([lat, lng], z, { duration: 0.5 });
                                },
                            }}
                        >
                            <Tooltip direction="top" offset={[0, -size / 2]} opacity={0.95}>{count} clienti · clicca per aprire</Tooltip>
                        </Marker>
                    );
                }
                return renderPoint(points[c.properties.idx]);
            })}
        </>
    );
};

export { CircleMarker, Popup };
export default ClusterLayer;
